import React from "react";

import { connect } from "react-redux";

import {
  Header,
  Icon as SemanticIcon,
  Image,
  Message
} from "semantic-ui-react";

import ReimbursementEditForm from "../../components/forms/ReimbursementEditForm";

import ReimbursementDisplay from "../../components/unauthenticated/ReimbursementDisplay";

import { Link } from "react-router-dom";

const submitterURL = submitter =>
  "/_/submitter/" + submitter.uuid + "/" + submitter.modify_key;

const ReimbursementView = props => {
  return (
    <div>
      <Header as="h2" dividing>
        <div style={{ float: "right", fontSize: "0.8em", marginTop: "0.5em" }}>
          <Link to={submitterURL(props.reimbursement.submitter)}>
            <SemanticIcon name="user" /> {props.reimbursement.submitter.name}
          </Link>
        </div>
        <SemanticIcon name="clipboard check" />
        <Header.Content>
          {props.reimbursement.description || "Your Reimbursement"}
          <Header.Subheader>
            {props.reimbursement.status === "received"
              ? "Complete and submit your reimbursement."
              : "View the status of your reimbursement."}
          </Header.Subheader>
        </Header.Content>
      </Header>
      {props.reimbursement.status === "received" && <ReimbursementEditForm />}
      {props.reimbursement.status !== "received" && (
        <ReimbursementDisplay reimbursement={props.reimbursement} />
      )}
      <Header as="h2" dividing style={{ paddingLeft: "10px" }}>
        Image
      </Header>
      <Image src={props.reimbursement.image} bordered rounded />
      {props.reimbursement.status === "received" && (
        <Message warning>
          Unsubmitted reimbursements are deleted after 14 days.
        </Message>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  reimbursement: state.unauthenticated.reimbursement
});

export default connect(mapStateToProps)(ReimbursementView);



// WEBPACK FOOTER //
// ./frontend/src/views/unauthenticated/ReimbursementView.js